import { ILiveLotteryDraw } from '@bg-shared/interfaces/Draws/ILiveLotteryDraw';
import { ILiveLotteryDraftState } from './interfaces';

export const mutations = {
    updateState: (draft: ILiveLotteryDraftState, data: ILiveLotteryDraw): void => {
        draft.data.drawCode = data.drawCode;
        draft.data.runId = data.runId;
    },
};
